import { render, staticRenderFns } from "./purchaseBarcode.vue?vue&type=template&id=837242b6&"
import script from "./purchaseBarcode.vue?vue&type=script&lang=js&"
export * from "./purchaseBarcode.vue?vue&type=script&lang=js&"
import style0 from "./purchaseBarcode.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports